const theme = {
    without_filters : ['Todos', 'All']
}
const renderProductsHome = () => {
    const allButtonFilters = document.querySelectorAll('.buttons-list-content .buttons-list__box .button')
    allButtonFilters?.length && allButtonFilters?.forEach( BtnFilter => {

        BtnFilter.addEventListener('click', (e) => {
            e.preventDefault()
            const data_filter = e?.target?.getAttribute('data-handle')
            const allButtons = document.querySelectorAll('.buttons-list-content .buttons-list__box .button')
            const allTabs = document.querySelectorAll('.collection-list-tab')
            const allProducts = document.querySelectorAll('.buttons-list-collections-products > .grid__item')

            allButtons?.forEach( ButtonFilter => {
                if(ButtonFilter?.getAttribute('data-handle') === data_filter) {
                    ButtonFilter.classList.add('active')
                } else {
                    ButtonFilter.classList.remove('active')
                }
            })

            allTabs?.forEach( TabFilter => {
                if(TabFilter?.getAttribute('data-tab') === data_filter) {
                    TabFilter.style.display = 'block'
                } else {
                    TabFilter.style.display = 'none'
                }
            })

            allProducts?.forEach( ProductFilter => {
                if(ProductFilter?.getAttribute('data-handle') === data_filter) {
                    ProductFilter.style.display = 'block'
                } else {
                    ProductFilter.style.display = 'none'
                }
            })
        })
    })

    const allButtonTagFilters = document.querySelectorAll('.collection-filtering')
    allButtonTagFilters?.length && allButtonTagFilters?.forEach( BtnTagFilter => {
        BtnTagFilter.addEventListener('click', (e) => {
            e.preventDefault()
            const current_tab = e.target.closest('.collection-list-tab')?.getAttribute('data-tab')
            if(e?.target?.className?.includes('active')) {
                e?.target?.classList?.remove('active')
            } else {
                e?.target?.classList?.add('active')
                const button_filter = e?.target?.getAttribute('data-filter')
                if(theme?.without_filters?.includes(button_filter)) {
                    clearAllTagFilter(current_tab)
                    return
                }
            }

            document.querySelector(`.collection-list-tab[data-tab="${current_tab}"] .filter-all`)?.removeAttribute('style')
            theme?.without_filters?.forEach( item => {
                document.querySelector(`.collection-list-tab[data-tab="${current_tab}"] button[data-filter="${item}"]`)?.classList?.remove('active')
            })

            const allFilteringArray = []
            const allFiltering = document.querySelectorAll(`.collection-list-tab[data-tab="${current_tab}"] .collection-filtering.active`)
            allFiltering?.forEach( filterTag => {
                filterTag?.getAttribute('data-filter') && allFilteringArray.push(filterTag?.getAttribute('data-filter'))
            })
            const allProducts = document.querySelectorAll('.buttons-list-collections-products > .grid__item')
            const currentHandleProduct = document.querySelector('.buttons-list-content .buttons-list__box .button.active')?.getAttribute('data-handle')
            allProducts?.forEach( ProductFilter => {
                const product_category_handle = ProductFilter?.getAttribute('data-handle')
                const product_tag_handle = ProductFilter?.getAttribute('data-tags')
                if(product_category_handle === currentHandleProduct) {
                    if(allFilteringArray?.some(filter => product_tag_handle?.includes(filter)) || !allFilteringArray?.length) {
                        ProductFilter.style.display = 'block'
                    } else {
                        ProductFilter.style.display = 'none'
                    }
                } else {
                    ProductFilter.style.display = 'none'
                }
            })
        })
    })

    const button_filter_all = document.querySelectorAll('.buttons-list-collections-filters button[data-filter="all"]')
    button_filter_all?.length && button_filter_all?.forEach( BtnTagAll => {
        BtnTagAll.addEventListener('click', (e) => {
            e.preventDefault()
            const current_tab = e.target.closest('.collection-list-tab')?.getAttribute('data-tab')
            clearAllTagFilter(current_tab)
        })
    })
}
const clearAllTagFilter = (current_tab = '') => {
    const allFiltering = document.querySelectorAll(`.collection-list-tab[data-tab="${current_tab}"] .collection-filtering`)
    allFiltering?.forEach( filterTag => {
        if(theme?.without_filters?.includes(filterTag?.getAttribute('data-filter'))) {
            filterTag?.classList?.add('active')
        } else {
            filterTag?.classList?.remove('active')
        }
    })

    const allProducts = document.querySelectorAll('.buttons-list-collections-products > .grid__item')
    allProducts?.forEach( ProductFilter => {
        const product_category_handle = ProductFilter?.getAttribute('data-handle')
        if(product_category_handle === current_tab) {
            ProductFilter.style.display = 'block'
        } else {
            ProductFilter.style.display = 'none'
        }
    })

    document.querySelector(`.collection-list-tab[data-tab="${current_tab}"] .filter-all`)?.setAttribute('style', 'display:none')
}
const enableLinkMenuHome = () => {
    const linkHash = ['#nosotros', '#contacto']
    linkHash.forEach( item => {
        const allLinks = document.querySelectorAll(`a[href="${item}"]`)
        allLinks?.forEach( link => {
            link?.addEventListener('click', (e) => {
                e.preventDefault()
                const current_path = window.top.location.pathname
                let currentLink = e?.target
                if(e?.target?.tagName !== 'A') {
                    currentLink = e?.target?.closest('a')
                }
                if(current_path !== '/') {
                    sessionStorage.setItem('windowGoTo', currentLink.getAttribute('href'))
                    window.top.location.href = '/'
                    return
                }
                const searchLink = document.querySelector(currentLink.getAttribute('href'))
                if(!searchLink) return
                window.scrollTo({top: (searchLink?.offsetTop - 100), behavior: 'smooth'})
            })
        })
    })
}
const evalAnimateOnLoad = () => {
    if(sessionStorage.getItem('windowGoTo')) {
        const searchLink = document.querySelector(sessionStorage.getItem('windowGoTo'))
        if(!searchLink) return
        window.scrollTo({top: (searchLink?.offsetTop - 100), behavior: 'smooth'})
        sessionStorage.removeItem('windowGoTo')
    }
}
const eventsProductPage = () => {
    const productMedia = document.querySelectorAll('.juliom087-body .product__media.media')
    productMedia?.forEach( productBoxMedia => {
        productBoxMedia?.addEventListener('click', (e) => {
            let containerImage = e?.target
            if(containerImage?.tagName === 'IMG') {
                containerImage = e?.target?.closest('.product__media.media')
            }
            if(containerImage?.className?.includes('image-magnify-full-size')) {
                containerImage = document.querySelectorAll('.juliom087-body .product__media.media')[0]
            }
            if(!containerImage?.className?.includes('custom-jm-pmedia')) {
                containerImage?.classList?.add('custom-jm-pmedia')
            } else {
                containerImage?.classList?.remove('custom-jm-pmedia')
            }
        })
        productBoxMedia?.addEventListener('mouseout', (e) => {
            let containerImage = e?.target
            if(containerImage?.className?.includes('image-magnify-full-size')) {
                containerImage = containerImage?.closest('.product__media.media')
                if(containerImage?.className?.includes('custom-jm-pmedia')) {
                    containerImage?.classList?.remove('custom-jm-pmedia')
                }
            }
        })
    })
}

window.onload = function() {
    renderProductsHome()
    enableLinkMenuHome()
    eventsProductPage()
    setTimeout(() => { evalAnimateOnLoad() }, 200)
}